import { FC } from 'react';
import { Box, Divider, Heading, Image, VStack } from '@chakra-ui/react';

import { ProviderPlanId } from '../../../../../../../__generated__/GQL';
import walletImg from '../../../../../../../assets/brand/wallet.png';
import { useCurrentPricingPlan } from '../../../../../../../common/hooks/useCurrentPricingPlan';
import SunshineCard from '../../../../../../../components/_core/SunshineCard';
import * as workRoutes from '../../../../../../Work/routes';
import * as routes from '../../../../../routes';
import EmptyStateOption from '../EmptyStateOption';
import locales from './locales';

interface MainBankAccountEmptyStateProps {
  bankAccountId: string | undefined;
}

export const MainBankAccountEmptyState: FC<MainBankAccountEmptyStateProps> = ({
  bankAccountId,
}) => {
  const { plan } = useCurrentPricingPlan();

  return (
    <>
      <Divider />

      <Box
        alignItems="center"
        display="flex"
        flexDirection="column"
        marginTop="space-32"
      >
        <VStack paddingX="space-16">
          <Image height={144} src={walletImg} width={144} />

          <Heading size="lg" textAlign="center" width="70%">
            {locales.headline}
          </Heading>

          <SunshineCard.Group border="none" isBoxed={false}>
            <EmptyStateOption
              icon="transfer"
              title={locales.sepaTitle}
              to={routes.getBankAccountDetailsPath(bankAccountId)}
            />

            {plan?.providerPlanId === ProviderPlanId.Basic ? null : (
              <>
                <EmptyStateOption
                  icon="cash"
                  mobileOnly
                  title={locales.cashTitle}
                />

                <Divider />

                <EmptyStateOption
                  icon="check"
                  mobileOnly
                  title={locales.checkTitle}
                />
              </>
            )}

            <EmptyStateOption
              icon="file"
              title={locales.invoicingClientsTitle}
              to={workRoutes.addInvoice}
            />
          </SunshineCard.Group>
        </VStack>
      </Box>
    </>
  );
};
